import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { GOLF_PARTNERSHIP_LIVE } from "@/config";

const PAGES = [
  { path: "/", label: "Home" },
  { path: "/performance", label: "Performance & Prestige" },
  { path: "/ev", label: "EV & Hybrid" },
  { path: "/why", label: "Why OWRS" },
  { path: "/gallery", label: "Workshop" },
  { path: "/sales", label: "Vehicles For Sale" },
  ...(GOLF_PARTNERSHIP_LIVE ? [{ path: "/golf", label: "Golf Partnership" }] : []),
  { path: "/contact", label: "Book In · Contact" },
];

export default function PageNav() {
  const { pathname } = useLocation();
  const idx = PAGES.findIndex((p) => p.path === pathname);
  if (idx === -1) return null;

  const prev = idx > 0 ? PAGES[idx - 1] : null;
  const next = idx < PAGES.length - 1 ? PAGES[idx + 1] : null;

  return (
    <nav
      data-testid="page-nav"
      className="border-t border-[var(--owrs-border)] bg-[var(--owrs-surface)]"
    >
      <div className="container-owrs grid grid-cols-2 divide-x divide-[var(--owrs-border)]">
        {prev ? (
          <Link
            to={prev.path}
            data-testid="page-nav-prev"
            className="group flex items-center gap-4 sm:gap-5 py-6 sm:py-8 pr-4 hover:bg-[var(--owrs-surface-2)] transition-colors"
          >
            <span className="h-9 w-9 sm:h-11 sm:w-11 inline-flex items-center justify-center border border-[var(--owrs-border-strong)] text-[var(--owrs-text-muted)] group-hover:bg-[var(--owrs-accent)] group-hover:text-[var(--owrs-accent-ink)] group-hover:border-[var(--owrs-accent)] transition-colors">
              <ArrowLeft className="h-4 w-4 sm:h-5 sm:w-5" />
            </span>
            <span className="text-left min-w-0">
              <span className="block text-[10px] sm:text-xs tracking-[0.28em] uppercase text-[var(--owrs-text-dim)] mb-1">
                Previous
              </span>
              <span className="block font-display text-base sm:text-xl truncate uppercase text-[var(--owrs-text)] group-hover:text-[var(--owrs-accent)] transition-colors">
                {prev.label}
              </span>
            </span>
          </Link>
        ) : (
          <div className="py-6 sm:py-8" />
        )}

        {next ? (
          <Link
            to={next.path}
            data-testid="page-nav-next"
            className="group flex items-center gap-4 sm:gap-5 py-6 sm:py-8 pl-4 hover:bg-[var(--owrs-surface-2)] transition-colors justify-end text-right"
          >
            <span className="min-w-0">
              <span className="block text-[10px] sm:text-xs tracking-[0.28em] uppercase text-[var(--owrs-text-dim)] mb-1">
                Next
              </span>
              <span className="block font-display text-base sm:text-xl truncate uppercase text-[var(--owrs-text)] group-hover:text-[var(--owrs-accent)] transition-colors">
                {next.label}
              </span>
            </span>
            <span className="h-9 w-9 sm:h-11 sm:w-11 inline-flex items-center justify-center border border-[var(--owrs-border-strong)] text-[var(--owrs-text-muted)] group-hover:bg-[var(--owrs-accent)] group-hover:text-[var(--owrs-accent-ink)] group-hover:border-[var(--owrs-accent)] transition-colors">
              <ArrowRight className="h-4 w-4 sm:h-5 sm:w-5" />
            </span>
          </Link>
        ) : (
          <div className="py-6 sm:py-8" />
        )}
      </div>
    </nav>
  );
}
